import { CircularProgress as MuiCircularProgress, CircularProgressProps as MuiCircularProgressProps } from '@mui/material';
import { createStyles, WithStyles, withStyles } from '@mui/styles';
import { DistributiveOmit } from '@mui/types';
import classNames from 'classnames';
import React from 'react';

import { LOADING_INDICATOR_ID } from '@/constants/testIds';
import { Theme } from '@/styles/theme';

const styles = (theme: Theme) =>
  createStyles({
    progress: {
      margin: theme.spacing(2),
    },
  });

type CircularProgressProps = DistributiveOmit<MuiCircularProgressProps, 'classes'>;
export interface Props extends WithStyles<typeof styles>, Partial<CircularProgressProps> {
  size?: number;
  className?: string;
}

function CircularProgress(props: Props) {
  const { classes, className, size } = props;
  return <MuiCircularProgress data-id={LOADING_INDICATOR_ID} disableShrink className={classNames(classes.progress, className)} size={size || 50} />;
}

export default withStyles(styles)(CircularProgress);
